import React from 'react';
import './ChartError.css';

const ChartError = ({
    error,
    isDarkMode = false,
    onRetry,
    onSelectDifferent,
    onReportIssue,
    selectedInstrument
}) => {
    const title = selectedInstrument
        ? `Unable to load ${selectedInstrument}`
        : 'Unable to load chart data';
    const message = error?.message || 'An unexpected error occurred while fetching data.';
    const details = error?.response?.status
        ? `Server responded with status ${error.response.status}`
        : error?.code;

    const renderAction = (label, handler, variant) => {
        if (!handler) return null;
        return (
            <button
                type="button"
                className={`ntc-chart-error-btn ${variant}`}
                onClick={handler}
            >
                {label}
            </button>
        );
    };

    return (
        <div className={`ntc-chart-error ${isDarkMode ? 'ntc-chart-error-dark' : 'ntc-chart-error-light'}`}>
            <div className="ntc-chart-error-card">
                <div className="ntc-chart-error-icon">!</div>
                <h3 className="ntc-chart-error-title">{title}</h3>
                <p className="ntc-chart-error-message">{message}</p>
                {details && (
                    <p className="ntc-chart-error-details">{details}</p>
                )}
                <div className="ntc-chart-error-actions">
                    {renderAction('Retry', onRetry, 'primary')}
                    {renderAction('Pick different asset', onSelectDifferent, 'ghost')}
                    {renderAction('Report issue', onReportIssue, 'secondary')}
                </div>
            </div>
        </div>
    );
};

export default ChartError;
